module.exports = __webpack_public_path__ + "media/images/editors-choice-0f342d934b36a60dbeaa8e847ae70af2.png";